import React from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarContent,
} from "react-pro-sidebar";
import { Link } from "react-router-dom";

import userDefaultPerfil from "../../images/perfil2.png";

import { useDispatch, useSelector } from "react-redux";
import { singOut } from "../../redux/auth/actions";
import { withRouter } from "react-router";

const SidebarModuloNotificaciones = (props) => {
  const dispatch = useDispatch();
  const userPic = useSelector((store) => store.auth.pic);
  const userN = useSelector((store) => store.auth.name);
  const userId = useSelector((store) => store.auth.id);
  const userType = useSelector((store) => store.auth.userType);

  const onSignOut = (e) => {
    e.preventDefault();
    dispatch(singOut(props));
  };
  return (
    <>
      <ProSidebar
        collapsed={false}
        className={`custom-sidebar ${props.show ? "show-sidebar" : ""}`}
        toggled={"fixed"}
      >
        <SidebarContent style={{ overflowY: "auto" }}>
          <Menu iconShape="square">

            <MenuItem icon={<i className="material-icons">face</i>}>
              <Link to={`/detalle-empleado/${userId}/${userType}`}>
                Ficha de empleado
              </Link>
            </MenuItem>
           {/*  <MenuItem icon={<i className="material-icons">notifications</i>}>
              <Link to="/conf-notificaciones/admin/tipo-notificacion">
                Tipo de Notificación
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">person</i>}>
              <Link to="/conf-notificaciones/admin/tipo-colaborador">
                Tipo de Colaborador
              </Link>
            </MenuItem> */}
            <MenuItem icon={<i className="material-icons">group_add</i>}>
              <Link to="/conf-notificaciones/admin/segmento">
                Segmento
              </Link>
            </MenuItem>



          </Menu>
        </SidebarContent>
      </ProSidebar>
    </>
  );
};

export default withRouter(SidebarModuloNotificaciones);
